const $body = $('body');

if ($(window).width() <= 1023) {
	$body.addClass('mobile-view');

	mobileNavigation();
}

$('.js-burger').on('click', function(e) {
	e.preventDefault();
	$body.toggleClass('menu-opened');
});

function mobileNavigation() {
	$('.js-has-dropdown > a').on('click', function(e) {
		if (
			!$(this)
				.parent()
				.hasClass('js-show')
		) {
			e.preventDefault();

			$(this)
				.next()
				.slideDown()
				.parent()
				.addClass('js-show')
				.siblings()
				.removeClass('js-show')
				.find('.menu__dropdown')
				.slideUp()
				.find('.js-show')
				.removeClass('js-show');
		} else {
			$(this)
				.parent()
				.removeClass('js-show')
				.find('.menu__dropdown')
				.slideUp()
				.find('.js-show')
				.removeClass('js-show');
		}
	});
}
